import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import EntryList from "../components/EntryList";
import client from "../api/client";

function FilteredEntriesPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [entries, setEntries] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const subcategory = searchParams.get("subcategory");
  const method = searchParams.get("method");
  const time_of_day = searchParams.get("time_of_day");
  const state = searchParams.get("state");
  const intention_tag = searchParams.get("intention_tag");
  const session_timing_keyword = searchParams.get("session_timing_keyword");

  //const filterLabel = subcategory || method || time_of_day || state || intention_tag || "Filtered";
  const filterLabel = subcategory || method || time_of_day || state || intention_tag
  || (session_timing_keyword ? `Setting: ${session_timing_keyword}` : null) || "Filtered";

  useEffect(() => {
    const fetchEntries = async () => {
      try {
        const res = await client.get("/entries/filtered", {
          params: { subcategory, method, time_of_day, state, intention_tag, session_timing_keyword }
        });
        setEntries(res.data);
      } catch (err) {
        setError("Unable to load entries.");
      } finally {
        setLoading(false);
      }
    };
    fetchEntries();
  }, [subcategory, method, time_of_day, state, intention_tag, session_timing_keyword]);

  if (loading) return <p>Loading...</p>;
  if (error) return <p>{error}</p>;

  return (
    <main className="FilteredEntriesPage">
      <h1 style={{ marginBottom: "4px" }}>{filterLabel}</h1>
      <p style={{ opacity: 0.7, fontSize: "13px", marginBottom: "24px" }}>
        {entries.length} {entries.length === 1 ? "entry" : "entries"}
      </p>
      <EntryList entries={entries} />
    </main>
  );
}

export default FilteredEntriesPage;